export function Functions (editor) {

    function addText(text){
        editor.insertContent(text);
    }

    editor.ui.registry.addButton("firstName", {
      text: "User's First Name",
      tooltip: "Insert User's First Name",
      onAction: function() {
        addText('[[firstname]]');
      }
    });

    editor.ui.registry.addButton("lastName", {
        text: "User's Last Name",
        tooltip: "Insert User's Last Name",
        onAction: function() {
            addText('[[lastname]]');
        }
    });

    editor.ui.registry.addButton("userEmail", {
    text: "User's Email Address",
    tooltip: "Insert User's Email Address",
    onAction: function() {
        addText('[[email]]');
    }
    });

    editor.ui.registry.addButton("clientName", {
        text: "Client Name",
        tooltip: "Insert Client Name",
        onAction: function() {
            addText('[[clientname]]');
        }
    });

    editor.ui.registry.addButton("clientDomain", {
        text: "Client Domain",
        tooltip: "Insert Client Domain",
        onAction: function() {
            addText('[[clienthostname]]');
        }
    });

    editor.ui.registry.addButton("todaysDate", {
        text: "Today's Date",
        tooltip: "Insert Today's Date",
        onAction: function() {
            addText('[[datenow]]');
        }
    });

    editor.ui.registry.addButton("currentDate", {
        text: "Current Date and Time",
        tooltip: "Insert Today's Date and Time",
        onAction: function() {
            addText('[[datetimenow]]');
        }
    });

    editor.ui.registry.addButton("startWeek", {
        text: "Start of the Week",
        tooltip: "Insert Start Date of Current Week",
        onAction: function() {
            addText('[[startcurrentweek]]');
        }
    });

    editor.ui.registry.addButton("endWeek", {
        text: "End of the Week",
        tooltip: "Insert End Date of Current Week",
        onAction: function() {
            addText('[[endcurrentweek]]');
        }
    });

    editor.ui.registry.addButton("eventName", {
        text: "Event Name",
        tooltip: "Insert Name of Event",
        onAction: function() {
            addText('[[eventname]]');
        }
    });

    editor.ui.registry.addButton("eventStartDate", {
        text: "Event Start Date",
        tooltip: "Insert Event Start Date",
        onAction: function() {
            addText('[[eventstartdate]]');
        }
    });

    editor.ui.registry.addButton("eventStartTime", {
        text: "Event Start Time",
        tooltip: "Insert Event Start Time",
        onAction: function() {
            addText('[[eventstarttime]]');
        }
    });

    editor.ui.registry.addButton("eventEndDate", {
        text: "Event End Date",
        tooltip: "Insert Event End Date",
        onAction: function() {
            addText('[[eventenddate]]');
        }
    });

    editor.ui.registry.addButton("eventEndTime", {
        text: "Event End Time",
        tooltip: "Insert Event End Time",
        onAction: function() {
            addText('[[eventendtime]]');
        }
    });

    editor.ui.registry.addButton("eventLocationDetails", {
        text: "Event Location Details",
        tooltip: "Insert Event Location Details",
        onAction: function() {
            addText('[[eventlocationdata]]');
        }
    });

    editor.ui.registry.addButton("eventDirectionsLink", {
        text: "Event Directions Link",
        tooltip: "Insert Event Directions Link",
        onAction: function() {
            addText('[[eventdirectionslink]]');
        }
    });

    editor.ui.registry.addButton("eventAdd", {
        text: "Event Add to Calendar",
        tooltip: "Insert Event Add to Calendar",
        onAction: function() {
            addText('[[eventaddtocalendar]]');
        }
    });

    editor.ui.registry.addButton("eventDetails", {
        text: "Event Details",
        tooltip: "Insert Event Details",
        onAction: function() {
            addText('[[eventdetails]]');
        }
    });

    editor.ui.registry.addButton("eventGuests", {
        text: "Event # of Guests",
        tooltip: "Insert Event # of Guests",
        onAction: function() {
            addText('[[eventguests]]');
        }
    });

    editor.ui.registry.addButton("emailJobLink", {
        text: "Email Apply Job Link",
        tooltip: "Insert Email Apply Job Link",
        onAction: function() {
            addText('[[emailapplylink]]');
        }
    });

    editor.ui.registry.addButton("emailJobTitle", {
        text: "Email Apply Job Title",
        tooltip: "Insert Email Apply Job Title",
        onAction: function() {
            addText('[[emailapplyjobtitle]]');
        }
    });

    editor.ui.registry.addButton("unsubscribeLink", {
        text: "Unsubscribe Link",
        tooltip: "Insert Job Alert Unsubscribe Link",
        onAction: function() {
            addText('<a href="http://[[clienthostname]]/talentnetwork/settings/%recipient.id%?isUnsubscribe=true">Unsubscribe From This Job Alert</a>');
        }
    });

    editor.ui.registry.addButton("updatePreferences", {
        text: "Update Preferences Link",
        tooltip: "Insert Update Preferences Link",
        onAction: function() {
            addText('<a href="http://[[clienthostname]]/talentnetwork/settings/%recipient.id%">Update Job Alert Preferences</a>');
        }
    });

    editor.ui.registry.addButton("jobAlerts", {
        text: "Job Alerts Data",
        tooltip: "Insert Job Alerts Data",
        onAction: function() {
            addText('[[data]]');
        }
    });
}